import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// Ensure HTTPS is used
if (!supabaseUrl.startsWith('https://')) {
  console.warn('Supabase URL should use HTTPS');
}

// Create Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    detectSessionInUrl: true,
    autoRefreshToken: true,
    storageKey: 'sb-psychics-auth-token',
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
});

// Enhanced realtime subscription with reconnection logic
const subscribeToRealtimeChannels = () => {
  let retryCount = 0;
  const MAX_RECONNECT_ATTEMPTS = 5;
  const RECONNECT_INTERVAL = 2000; // 2 seconds

  const channel = supabase.channel('custom-all-channel')
    .on(
      'postgres_changes',
      { event: '*', schema: 'public', table: 'messages' },
      (payload) => {
        console.log('Message change received:', payload.eventType);
      }
    )
    .on(
      'postgres_changes',
      { event: '*', schema: 'public', table: 'conversations' },
      (payload) => {
        console.log('Conversation change received:', payload.eventType);
      }
    )
    .on(
      'postgres_changes',
      { event: '*', schema: 'public', table: 'webrtc_signals' },
      (payload) => {
        console.log('WebRTC signal received:', payload.eventType);
      }
    )
    .subscribe((status) => {
      console.log('Realtime subscription status:', status);
      
      if (status === 'CHANNEL_ERROR') {
        if (retryCount < MAX_RECONNECT_ATTEMPTS) {
          retryCount++;
          console.log(`Channel error, attempting to reconnect (attempt ${retryCount})...`);
          setTimeout(() => {
            subscribeToRealtimeChannels();
          }, RECONNECT_INTERVAL * Math.pow(2, retryCount - 1)); // Exponential backoff
        } else {
          console.error('Max reconnection attempts reached');
        }
      } else if (status === 'SUBSCRIBED') {
        retryCount = 0; // Reset retry count on successful connection
      }
    });

  return channel;
};

// Initialize realtime subscriptions
subscribeToRealtimeChannels();

// Verify client initialization
if (!supabase.from || !supabase.channel) {
  throw new Error('Supabase client not properly initialized');
}

export default supabase;